module.exports = require('./helpers/bundle-url').getBundleURL('hkxlb') + "captain_marvel.a971ec72.png";